import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=b0a63e8a&scoped=true"
import script from "./Square.vue?vue&type=script&lang=js"
export * from "./Square.vue?vue&type=script&lang=js"
import style0 from "./Square.vue?vue&type=style&index=0&id=b0a63e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a63e8a",
  null
  
)

export default component.exports